import { useFormikContext } from 'formik'
import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import type { WithdrawalFormValues } from '../WithdrawalFlowLayout/types'
import { WithdrawalFailedContent } from './WithdrawalFailedContent'
import { WithdrawalSuccessContent } from './WithdrawalSuccessContent'

type TransactionStatus = 'success' | 'failed'

export const WithdrawalTransactionPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { status } = useParams<{ status: TransactionStatus }>()
  const { values } = useFormikContext<WithdrawalFormValues>()

  const onTryAgain = () => {
    const dashboardContext = values.dashboardContext ?? 'traders-room'
    navigate(`/dashboard/${dashboardContext}/withdrawal/wallet`, {
      replace: true,
      state: location.state,
    })
  }

  if (status === 'failed') {
    return <WithdrawalFailedContent onTryAgain={onTryAgain} />
  }

  return <WithdrawalSuccessContent />
}
